import { observable } from "mobx";
import {
  queryFreelancerTaskList,
  queryFreelancerTaskDetail,
  queryTaskDetail,
  acceptTask,
  rejectTask,
  completeTask,
  queryDelivery,
  editDelivery
} from '@/services/task';

// 任务大厅信息
const task = observable({
  taskList: [], // 灵工任务列表
  pageCount: 0,
  taskDetail: {},
  // 获取灵工任务列表
  async queryFreelancerTaskList(payload) {
    const { pageCount, dataList, pageNo } = await queryFreelancerTaskList(payload);
    this.pageNo = pageNo;
    this.pageCount = pageCount;
    this.taskList = pageCount === 1 ? dataList : this.taskList.concat(dataList || []);
  },
  // 查询灵工任务详情
  async queryFreelancerTaskDetail(payload) {
    const data = await queryFreelancerTaskDetail(payload);
    this.taskDetail = { ...data };
  },
  // 查询企业任务详情
  async queryTaskDetail(payload) {
    const data = await queryTaskDetail(payload);
    this.taskDetail = { ...data };
  },
  // 接受任务
  async acceptTask(payload) {
    const data = await acceptTask(payload);
    this.taskAccept = { ...data };
  },
  // 拒绝任务
  async rejectTask(payload) {
    await rejectTask(payload)
  },
  // 清空列表信息
  async clearListInfo() {
    this.pageNo = 0;
    this.pageCount = 0;
    this.taskList = [];
  },
  // 确认完成任务
  async completeTask(payload) {
    await completeTask(payload);
  },
  // 查询交付物
  async queryDelivery(payload) {
    const data = await queryDelivery(payload);
    Object.assign(this, data);
  },
  // 编辑交付物
  async editDelivery(payload) {
    await editDelivery(payload);
  },
});

export default task;
